import { createSlice } from '@reduxjs/toolkit';
import { deleteCustomerSettings,
    editCustomerDetails,
    getAllCompanies,
    getChannelAndVendor,
    getCompanyByHash,
    getCustomerSettings,
    getEditCustomerSettings,
    getUserCompany } from '../thunks/companyThunks';
import { toast } from 'react-toastify';
const DEV_AWS_BUCKET_PATH = 'https://pfiq-v1-dev';
const PROD_AWS_BUCKET_PATH = 'https://pfiq-v1-prod';
  
const company = createSlice({
    name: 'company',
    initialState: {
        isLoading: false,
        error: null,
        companyHash: null,
        company: {
            id: null,
            name: null
        },
        companies: [],
        companyOptions: [],
        customersSetting: {
            isLoading: true,
            customersSettings: [],
            editCustomer: [],
            editCustomerData: {
                id: '',
                content_type: [{
                    id: 1,
                    subject_line: '',
                    content_type: null
                }]
            },
            isChecked: false,
            isDeleted: 0,
            channel: [],
            vendor: [],
            customerDataForEdit: [
                {
                    content: '',
                    image: '',
                    id: '',
                    company_id: '',
                    channel: '',
                    topic: '',
                    vendor: '',
                    subject_line: '',
                    content_type: [{
                        id: 1,
                        subject_line: '',
                        content_type: null
                    }]
                }
            ],
            subject_line: []
        },
        isOmaniChannel: false
    },
    reducers: {
        setCompanyHash: (state, action) => {
            const params = new URLSearchParams(location.search);
            let c = params.get('c');
            
            if (c !== null) {
                localStorage.setItem('c', c);
                window.history.replaceState({}, document.title, location.pathname);
            } else {
                c = localStorage.getItem('c') ?? '';
            }
        },
        setCompany: (state, action) => {
            const {
                label, value, companyDetails 
            } = action.payload;
            state.company = { id: value, name: label };
            const hash = companyDetails.hash_id;
            if(hash){
                localStorage.setItem('c', hash);
            }
        },
        editCustomer: (state,action) => {
            const { data } = action.payload;
            
            if(data === null){
                state.customersSetting.editCustomer = [];
                state.customersSetting.isChecked = false;
                state.customersSetting.editCustomerData = {
                    content_type: [{
                        id: 1,
                        subject_line: '',
                        content_type: null
                    }]
                };
            } else{
                state.customersSetting.editCustomer = [];
                state.customersSetting.isChecked = false;
                state.customersSetting.editCustomerData = {
                    content_type: [{
                        id: 1,
                        subject_line: '',
                        content_type: null
                    }]
                };
                state.customersSetting.editCustomer = data;
            }
        },
        getDataForEdit: (state, action) => {
            const { field, value } = action.payload.payload;
        
            if (field === 'content_type') {
                const { id, content_type } = value;
                const updatedEditCustomerData = { ...state.customersSetting.editCustomerData };
                const updatedContentType = updatedEditCustomerData.content_type.map(content => {
                    if (content.id === id) {
                        return {
                            ...content,
                            content_type: content_type
                        };
                    }
                    return content;
                });
                if (!updatedContentType.some(content => content.id === id)) {
                    updatedContentType.push({ id, content_type });
                }
                updatedEditCustomerData.content_type = updatedContentType;
        
                return {
                    ...state,
                    customersSetting: {
                        ...state.customersSetting,
                        editCustomerData: updatedEditCustomerData
                    }
                };
            } else if (field === 'subject_line') {
                const { id, subject_line } = value;
                const updatedEditCustomerData = { ...state.customersSetting.editCustomerData };
                const updatedContentType = updatedEditCustomerData.content_type.map(content => {
                    if (content.id === id) {
                        return {
                            ...content,
                            subject_line: subject_line
                        };
                    }
                    return content;
                });
                if (!updatedContentType.some(content => content.id === id)) {
                    updatedContentType.push({ id, subject_line });
                }
                updatedEditCustomerData.content_type = updatedContentType;
        
                return {
                    ...state,
                    customersSetting: {
                        ...state.customersSetting,
                        editCustomerData: updatedEditCustomerData
                    }
                };
            } else {
                const updatedCustomerDataForEdit = { ...state.customersSetting.editCustomerData };
                updatedCustomerDataForEdit[field] = value;
        
                return {
                    ...state,
                    customersSetting: {
                        ...state.customersSetting,
                        editCustomerData: updatedCustomerDataForEdit
                    }
                };
            }
        },
        
        removeContentType: (state, action) => {
            const { id } = action.payload;
            const updatedEditCustomerData = { ...state.customersSetting.editCustomerData };
            const updatedContentTypes = updatedEditCustomerData.content_type
                .filter(content => content.id !== id);

            updatedEditCustomerData.content_type = updatedContentTypes;

            return {
                ...state,
                customersSetting: {
                    ...state.customersSetting,
                    editCustomerData: updatedEditCustomerData
                }
            };
        },
        
        addContentType: (state, action) => {
            const updatedEditCustomerData = { ...state.customersSetting.editCustomerData };
            const highestId = Math.max(...updatedEditCustomerData.content_type
                .map(content => content.id), 0);
            const newContentTypeObject = {
                id: highestId + 1,
                subject_line: '',
                content_type: null
            };
            updatedEditCustomerData.content_type = [
                ...updatedEditCustomerData.content_type,
                newContentTypeObject
            ];
        
            return {
                ...state,
                customersSetting: {
                    ...state.customersSetting,
                    editCustomerData: updatedEditCustomerData
                }
            };
        },
        
        updateSubjectLine: (state, action) => {
            const { id, value } = action.payload;
            const updatedSubjectLine = state.subject_line.map((line) => {
                if (line.id === id) {
                    return {
                        ...line,
                        subjectLine: value
                    };
                }
                return line;
            });

            return {
                ...state,customersSetting: {
                    ...state.customersSetting,
                    subject_line: updatedSubjectLine
                }
            };
        },
        triggerIsChecked: (state, action) => {
            state.customersSetting.isChecked = !state.customersSetting.isChecked;
        },
        getIsOmaniChannel: (state, action) => {
            
            const { companyId, companies } = action.payload;
            const selectedCompany = companies?.filter(cmp => cmp.id === companyId);
            state.isOmaniChannel = selectedCompany[0]?.dashboard_type === 'DTC' ? 1 : 0;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllCompanies.fulfilled, (state, action) => {
                state.isLoading = false;
                if(action?.payload?.companies){
                    state.companies = action?.payload?.companies;
                    state.companyOptions = action?.payload?.companies?.map(companyData => ({
                        label: companyData?.name,
                        value: companyData?.id,
                        companyDetails: companyData 
                    }));
                    
                }
                state.error = null;
            })
            .addCase(getAllCompanies.pending, (state, action) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getAllCompanies.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(getCompanyByHash.fulfilled, (state, action) => {
                state.isLoading = false;
                for (const [key, value] of Object.entries(state.company)) {
                    state.company[key] = action.payload.company ? 
                        (action.payload.company.hasOwnProperty(key) ? 
                            action.payload.company[key] : value)
                        : action.payload.companies.hasOwnProperty(key) ? 
                            action.payload.companies[key] : value;
                }
                state.error = null;
            })
            .addCase(getCompanyByHash.pending, (state, action) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getCompanyByHash.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(getUserCompany.fulfilled, (state, action) => {
                state.isLoading = false;
                const userCompany = action.payload.company || {};
                state.isOmaniChannel = userCompany.dashboard_type === 'DTC' ? 1 : 0;
                for (const [key, value] of Object.entries(state.company)) {
                    state.company[key] = action.payload.company.hasOwnProperty(key)
                        ? action.payload.company[key]
                        : value;
                }
                state.companyOptions = [{
                    label: action.payload.company.name, 
                    value: action.payload.company.id, 
                    companyDetails: action.payload.company
                }];

                state.error = null;
            })
            .addCase(getUserCompany.pending, (state, action) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getUserCompany.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(getCustomerSettings.fulfilled, (state, action) => {
                if(action?.payload?.status_code===200){
                    state.customersSetting.isLoading = false;
                    state.customersSetting.customersSettings = getCustomerSettingsData(action.payload?.result);
                    state.error = null;
                } else{
                    toast.error('Something went wrong!');
                    state.customersSetting.isLoading = false;
                }
            })
            .addCase(getCustomerSettings.pending, (state, action) => {
                state.customersSetting.isLoading = true;
                state.error = null;
            })
            .addCase(getCustomerSettings.rejected, (state, action) => {
                state.customersSetting.isLoading = false;
                state.error = action.payload;
                toast.error('Something went wrong!');
            })
            .addCase(getEditCustomerSettings.fulfilled, (state, action) => {
                if(action?.payload?.status_code===200){
                    state.customersSetting.isLoading = false;
                    state.customersSetting.editCustomerData = getEditCustomerSettingsData(action.payload?.result);
                    state.error = null;
                } else{
                    toast.error('Something went wrong!');
                    state.customersSetting.isLoading = false;
                }
            })
            .addCase(getEditCustomerSettings.pending, (state, action) => {
                state.customersSetting.isLoading = true;
                state.error = null;
            })
            .addCase(getEditCustomerSettings.rejected, (state, action) => {
                state.customersSetting.isLoading = false;
                state.error = action.payload;
                toast.error('Something went wrong!');
            })
            .addCase(getChannelAndVendor.fulfilled, (state, action) => {
                if(action?.payload?.status_code===200){
                    state.customersSetting.isLoading = false;
                    state.customersSetting.channel = getChannelOption(action.payload?.result || []);
                    state.customersSetting.vendor = getVendorOption(action.payload?.vendor || []);
                    state.error = null;
                } else{
                    toast.error('Something went wrong!');
                    state.customersSetting.isLoading = false;
                }
            })
            .addCase(getChannelAndVendor.pending, (state, action) => {
                state.customersSetting.isLoading = true;
                state.error = null;
            })
            .addCase(getChannelAndVendor.rejected, (state, action) => {
                state.customersSetting.isLoading = false;
                state.error = action.payload;
                toast.error('Something went wrong!');
            })
            .addCase(editCustomerDetails.fulfilled, (state, action) => {
                if(action?.payload?.status_code===200){
                    state.customersSetting.isLoading = false;
                    state.error = null;
                    if(state.customersSetting.editCustomer.length > 0){
                        toast.success('data updated successfully');
                    } else{
                        toast.success('data submitted successfully'); 
                    }
                    
                } else{
                    toast.error('Something went wrong!');
                    state.customersSetting.isLoading = false;
                }
            })
            .addCase(editCustomerDetails.pending, (state, action) => {
                state.customersSetting.isLoading = true;
                state.error = null;
            })
            .addCase(editCustomerDetails.rejected, (state, action) => {
                state.customersSetting.isLoading = false;
                state.error = action.payload;
                toast.error('Something went wrong!');
            })

            .addCase(deleteCustomerSettings.fulfilled, (state, action) => {
                state.customersSetting.isLoading = false;
                state.error = null;
                state.customersSetting.isDeleted+= 1;
                toast.success(action.payload.message);
            })
            .addCase(deleteCustomerSettings.pending, (state, action) => {
                state.customersSetting.isLoading = true;
                state.error = null;
            })
            .addCase(deleteCustomerSettings.rejected, (state, action) => {
                state.customersSetting.isLoading = false;
                state.error = action.payload;
                toast.error('Something went wrong!');
            });
            
    }
});

const getChannelOption = (data) => {
    const channelOption = [];
    if(data){
        data?.map(channel => {
            channelOption.push({
                id: channel.id,
                label: channel.name,
                value: channel.name
            });
        });
        return channelOption;
    }
    return channelOption;
};

const getVendorOption = (data) => {
    const vendorOption = [];
    if(data){
        data?.map(vendor => {
            vendorOption.push({
                id: vendor.id,
                label: vendor.name,
                value: vendor.name
            });
        });
        return vendorOption;
    }
    return vendorOption;
};

const getEditCustomerSettingsData = (data) => {
    if(data){
        if (data.content_type === null || data.content_type === undefined) {
            return {
                ...data,
                content_type: [{
                    id: 1,
                    subject_line: '',
                    content_type: null
                }]
            };
        } else {
            return {
                ...data,
                content_type: Array.isArray(data?.content_type) ? data?.content_type : JSON.parse(data?.content_type || '[]'),
                image: handleImageSource(data.image)
            };
        }
    }
};

const getCustomerSettingsData = (data) => {
    if (data) {
        return data.map(item => ({
            ...item,
            image: handleImageSource(item.image)
        }));
    }
    return [];
};


const handleImageSource = (image_path) => {
    let image_url = '';
    if (image_path){
        if (image_path.includes(DEV_AWS_BUCKET_PATH) || image_path.includes(PROD_AWS_BUCKET_PATH)){
            image_url = image_path;
        }else{
            image_url = window.location.origin + '/image/' + image_path;
        }
    } else{
        image_url = '/images/upload_placeholder.png';
    }
    return image_url;
};

export const { actions } = company;
export default company.reducer;
